import React from 'react';
import { Row, Col, Button, Typography } from 'antd';
import { useAuth0 } from '../react-auth0-spa';

const { Title } = Typography;

const Logout = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <>
      <div style={{ marginTop: '200px' }}>
        <Row type="flex" justify="center">
          <Col
            xs={12}
            md={12}
            xl={12}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Title level={4}>Wylogowano z aplikacji</Title>
          </Col>
        </Row>
        <Row type="flex" justify="center">
          <Col
            xs={12}
            md={6}
            xl={6}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Button
              style={{
                marginTop: '36px',
                width: '200px',
              }}
              size={'large'}
              type={'link'}
              onClick={() => loginWithRedirect({})}
            >
              Zaloguj ponownie
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Logout;
